const blog = {
    title: 'Learn more',
    seeAll: 'See all',
}

export default blog
